"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _DragAndDrop = require("./DragAndDrop");
var _InlineWysiwyg = _interopRequireDefault(require("./InlineWysiwyg"));
var _SectionTitle = _interopRequireDefault(require("./SectionTitle"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CeApprovalStatements = function CeApprovalStatements(_ref) {
  var formProps = _ref.formProps;
  var sections = formProps.values.courseDescription.ceApprovalStatements.sections;
  var setStatements = function setStatements(statements) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, {
        ceApprovalStatements: _objectSpread(_objectSpread({}, formProps.values.courseDescription.ceApprovalStatements), {}, {
          sections: statements
        })
      })
    }));
  };
  var onDragEnd = function onDragEnd(result) {
    if (!result.destination || !result.source) {
      return;
    }
    var fromIndex = result.source.index;
    var toIndex = result.destination.index;
    var statements = (0, _DragAndDrop.dndSwap)(sections.map(function (statement) {
      return _objectSpread({}, statement);
    }), fromIndex, toIndex);
    setStatements(statements);
  };
  var onClickAdd = function onClickAdd() {
    var statements = sections.map(function (statement) {
      return _objectSpread({}, statement);
    });
    var highestKey = 0;
    statements.forEach(function (statement) {
      if (statement.key > highestKey) {
        highestKey = statement.key;
      }
    });
    statements.push({
      title: '',
      subtitle: '',
      description: '',
      key: highestKey + 1
    });
    setStatements(statements);
  };
  var onClickDelete = function onClickDelete(key) {
    var statements = sections.filter(function (statement) {
      return statement.key !== key;
    });
    setStatements(statements);
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "CE Approval Statements"), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: "ceApprovalStatements",
    placeholder: "CE Approval Statements"
  }), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "ce-approval-statements"
  }, function (dropProvided, dropSnapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, dropProvided.droppableProps, {
      ref: dropProvided.innerRef,
      className: "form-group"
    }), dropProvided.placeholder, sections.map(function (statement, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: "statement-".concat(statement.key),
        index: index,
        key: "statement-".concat(statement.key)
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps, dragProvided.dragHandleProps, {
          className: _style["default"].dragContainer
        }), dragProvided.placeholder, /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndArrows, null), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].dragAndDropContent
        }, /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.ceApprovalStatements.sections[".concat(index, "].title"),
          label: "Title"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.ceApprovalStatements.sections[".concat(index, "].subtitle"),
          label: "Subtitle"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.ceApprovalStatements.sections[".concat(index, "].description"),
          label: "Description"
        })), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndDeleteButton, {
          onClick: function onClick() {
            return onClickDelete(statement.key);
          }
        }));
      });
    }), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndAddButton, {
      onClick: onClickAdd
    }));
  })));
};
var _default = CeApprovalStatements;
exports["default"] = _default;